module.exports = __webpack_public_path__ + "fonts/SuisseIntl-Black.da0828a.woff2";